// -------------------------------------------------
// スクロール検知：body に .is-scroll、ヘッダーに .scroll-active を付与
// トップ（.p-top）のみ：.s-about セクションを通過するまで付与しない
// -------------------------------------------------
class ScrollObserve {
  constructor() {
    this.body = document.body;
    this.header = document.querySelector('.js-header');
    this.scrollThreshold = 1; // 1px以上スクロールで付与（トップ以外）
    this.init();
  }

  init() {
    this.checkScroll();
    window.addEventListener('scroll', () => this.checkScroll(), { passive: true });
    window.addEventListener('resize', () => this.checkScroll(), { passive: true });
    // 初回表示時・リサイズ時にもチェック
    window.addEventListener('load', () => this.checkScroll());
  }

  getScrollTop() {
    return window.scrollY ?? document.documentElement.scrollTop ?? 0;
  }

  /**
   * トップページ：ビューポート上端が .s-about の下端を過ぎたら true
   */
  isPastAboutSection() {
    const about = document.querySelector('.p-top .s-about');
    if (!about) return this.getScrollTop() >= this.scrollThreshold;
    return about.getBoundingClientRect().bottom <= 0;
  }

  checkScroll() {
    const isTop =
      this.header && this.header.classList.contains('p-top');
    const isScrolled = isTop
      ? this.isPastAboutSection()
      : true;
    if (isScrolled) {
      this.body.classList.add('is-scroll');
      if (this.header) this.header.classList.add('scroll-active');
    } else {
      this.body.classList.remove('is-scroll');
      if (this.header) this.header.classList.remove('scroll-active');
    }
  }
}
